<template>
  <div class="china-map-wrapper" style="position: relative; width: 100%; height: 100%;">
    <div ref="chart" class="china-map"></div>
    <div v-if="popupVisible" class="province-popup" :style="{ left: popupX + 'px', top: popupY + 'px' }">
      <div class="popup-content">
        <div class="school-list">
          <span v-for="school in popupSchools" :key="school" class="school-item">
            <span class="school-underline" @click="goToSchool(school.url)">{{ school.isJoin==='是' ? '*' : '' }} {{ school.schoolName }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import chinaMap from '@/assets/china.json'
import { talentApi } from '@/api/talent'
export default {
  name: 'ChinaMap',
  data() {
    return {
      popupVisible: false,
      popupX: 0,
      popupY: 0,
      popupSchools: [],
      popupProvince: '',
      provinceSchoolMap: {
        '内蒙古自治区': [
          '内蒙古科技大学', '内蒙古工业大学', '内蒙古农业大学',
          '内蒙古农业大学', '内蒙古大学', '内蒙古民族大学',
          '内蒙古民族大学', '呼伦贝尔学院'
        ],
        // 可继续添加其他省份
      }
    }
  },
  mounted() {
    echarts.registerMap('china', chinaMap); // 注册地图
    this.initChart();
    this.getSchoolByProvince();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    formatUrl(url) {
      if (!url) return '#'
      // 如果URL已经包含协议，直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 如果URL以//开头，添加https:
      if (url.startsWith('//')) {
        return 'https:' + url
      }
      // 如果URL以www开头，添加https://
      if (url.startsWith('www.')) {
        return 'https://' + url
      }
      // 其他情况添加https://
      return 'https://' + url
    },
    getSchoolByProvince() {
      talentApi.queryAllSchool(this.$route.query.id).then(res => {
        console.log("res数据" + res)
        this.provinceSchoolMap = res.rows
      })
    },
    initChart() {
      const chart = echarts.init(this.$refs.chart);
      this.chart = chart;

      const option = {
        backgroundColor: 'transparent',
        tooltip: { show: false },
        visualMap: {
          type: 'piecewise',
          left: '40px',
          bottom: 60,
          min: 0,
          max: 150,
          show: true,
          text: ['应届高校毕业生', ''],
          showLabel: true,
          pieces: [
            { min: 80, max: 150, color: '#222DFF', label: '80–150W' },
            { min: 60, max: 80, color: '#5F67FF', label: '60–80W' },
            { min: 40, max: 60, color: '#3FA1E4', label: '40–60W' },
            { min: 20, max: 40, color: '#3EB8FE', label: '20–40W' },
            { min: 0, max: 20, color: '#8EE9FF', label: '0–20W' }
          ],
          textStyle: {
            color: '#222',
            fontSize: 16,
            fontWeight: 500
          },
          itemWidth: 32,
          itemHeight: 14,
          borderRadius: 6,
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          padding: [18, 24, 18, 24],
          shadowColor: 'rgba(0,0,0,0.08)',
          shadowBlur: 12,
          orient: 'vertical'
        },
        series: [
          {
            name: '中国地图',
            type: 'map',
            map: 'china',
            roam: false, // 禁止缩放和拖拽
            layoutCenter: ['50%', '60%'], // 地图居中
            layoutSize: '100%',            // 地图尽量大
            selectedMode: 'single', // 必须加上
            label: { show: true, color: '#fff', fontSize: 13,textShadowBlur: 10, textShadowColor: '#000' },
            itemStyle: { areaColor: '#0E9CFE', borderColor: '#fff', borderWidth: 1.5 },
            emphasis: {
              label: { show: true, color: '#fff', fontSize: 14, textShadowBlur: 10, textShadowColor: '#000' },
              itemStyle: { areaColor: '#408FFF' }
            },
            select: {
              label: { show: true, color: '#fff', fontSize: 14 },
              itemStyle: { areaColor: '#408FFF' }
            },
            selectedMode: 'single', // 支持点击选中省份
            data: [
              { name: '河南省', value: 118 },
              { name: '广东省', value: 105 },
              { name: '山东省', value: 85 },
              { name: '江苏省', value: 83 },
              { name: '四川省', value: 70 },
              { name: '湖北省', value: 65 },
              { name: '河北省', value: 62 },
              { name: '湖南省', value: 58 },
              { name: '安徽省', value: 55 },
              { name: '浙江省', value: 50 },
              { name: '陕西省', value: 44 },
              { name: '重庆市', value: 40 },
              { name: '辽宁省', value: 38 },
              { name: '福建省', value: 35 },
              { name: '广西壮族自治区', value: 32 },
              { name: '云南省', value: 30 },
              { name: '贵州省', value: 28 },
              { name: '吉林省', value: 25.2 },
              { name: '山西省', value: 25 },
              { name: '江西省', value: 24 },
              { name: '黑龙江省', value: 22 },
              { name: '新疆维吾尔自治区', value: 20 },
              { name: '甘肃省', value: 18 },
              { name: '上海市', value: 18 },
              { name: '北京市', value: 16 },
              { name: '内蒙古自治区', value: 15.8 },
              { name: '天津市', value: 15 },
              { name: '海南省', value: 10 },
              { name: '宁夏回族自治区', value: 7 },
              { name: '青海省', value: 5 },
              { name: '西藏自治区', value: 3 }
            ],
            markPoint: {
              symbol: 'pin',
              symbolSize: 40,
              data: [
              ]
            }
          }
        ]
      };

      chart.setOption(option);

      // 监听选中事件
      chart.on('selectchanged', params => {
        console.log("选中" + JSON.stringify(params));

        if (params.fromAction === 'select' && params.batch && params.batch.length > 0) {
          const selected = params.batch[0].selected;
          const province = Object.keys(selected)[0];
          if (province) {
            chart.setOption({
              series: [{
                markPoint: {
                  symbol: 'pin',
                  symbolSize: 40,
                  data: [{ name: province }]
                }
              }]
            });
            // 弹出信息框
            this.$message && this.$message.info ? this.$message.info(province) : alert(province);
          } else {
            // 取消选中时移除点
            chart.setOption({
              series: [{
                markPoint: { data: [] }
              }]
            });
          }
        }
      });
      // 兼容直接点击地图区域弹框
      chart.on('click', params => {
        if (params && params.name) {
          // 获取鼠标坐标
          const event = params.event && params.event.event;
          let x = 100, y = 100;
          if (event) {
            x = event.offsetX;
            y = event.offsetY;
          }
          let province = params.name
          province = province.replace("省", "")
          province = province.replace("自治区", "")
          province = province.replace("市", "")
          let schools = []
          this.provinceSchoolMap.forEach(item => {
            if(item.province === province){
              schools.push(item)
            }
          })
          if (schools.length == 0) {
            this.popupVisible = false;
            this.$message && this.$message.info ? this.$message.info("暂无数据") : alert("暂无数据");
            return
          }
          // 对schools进行去重
          const schoolMap = new Map()
          schools.forEach(item => {
            let cleanName = item.schoolName
          
            if (cleanName && !schoolMap.has(cleanName)) {
              schoolMap.set(cleanName, {
                ...item,
                configName: cleanName
              })
            }
          })
          
          const uniqueSchools = Array.from(schoolMap.values())
          console.log('学校去重前:', schools.length, '去重后:', uniqueSchools.length)

          this.popupVisible = true;
          this.popupX = x;
          this.popupY = y;
          this.popupSchools = uniqueSchools;
          this.popupProvince = params.name;
        } else {
          this.popupVisible = false;
        }
      });
      // 点击地图空白处关闭弹框
      chart.getZr().on('click', (e) => {
        if (!e.target) {
          this.popupVisible = false;
        }
      });
    },
    goToSchool(url) {
      if (url) window.open(this.formatUrl(url), '_blank');
    },
    handleResize() {
      // 使用防抖优化性能
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
    }
  },
  beforeDestroy() {
    // 移除窗口resize监听
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style scoped>
.china-map-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.china-map {
  width: 100%;
  height: 100%;
}

.province-popup {
  position: absolute;
  z-index: 9999;
  width: 230px;
  padding-bottom: 20px;
  color: #fff;
  pointer-events: auto;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background: linear-gradient(180deg, #0116FF 0%, #5F6CFC 82%, #ACB2FF 100%);
}

.popup-arrow {
  position: absolute;
  left: -16px;
  top: 18px;
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-right: 16px solid #1B77FF;
}

.popup-content {
  margin-left: 8px;
}

.school-list {
  margin: 10px;
  margin-top: 30px;
  max-height: 300px;
  overflow-y: auto;
  grid-template-columns: repeat(3, 0.5fr);
  gap: 2px 2px;
}

.school-item {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  line-height: 1.6;
  background: transparent;
  text-align: center;
}

.school-item .school-underline {
  display: inline-block;
  border-bottom: 2px solid #fff;
  padding: 0 2px;
  line-height: 1.6;
  text-shadow: 0 0 5px #000;
}


.map-legend {
  position: absolute;
  right: 40px;
  bottom: 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  padding: 18px 24px 18px 24px;
  z-index: 1000;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
}

.legend-color {
  display: inline-block;
  width: 24px;
  height: 10px;
  border-radius: 2px;
  margin-right: 12px;
}

.legend-label {
  color: #222;
  font-size: 16px;
  font-weight: 500;
}
</style>